import React, { useContext, useMemo } from "react";
import { noop } from "@common/helpers/function";
import { useScopeCloses } from "@api/close.api";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { CloseSelectOption } from "@components/tasks/TaskView/Cells/CloseSelectOption";
import {
    getCloseClientName,
    TaskClientNamesContext,
} from "@components/tasks/taskClientNamesContext";
import { FilterActionsFooter } from "@design-system/Filter/FilterActionsFooter/FilterActionsFooter";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

export const TaskCloseFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: closes = [] } = useScopeCloses();
    const clientNamesById = useContext(TaskClientNamesContext);

    const options = useMemo<FilterMultiselectOption[]>(
        () =>
            closes.map((close) => {
                const clientName = getCloseClientName(close, clientNamesById);

                return {
                    value: close.id,
                    label: (
                        <CloseSelectOption
                            entityId={close.entityId}
                            clientName={clientName}
                            name={close.name}
                            startDate={close.startDate}
                            endDate={close.endDate}
                        />
                    ),
                    searchableLabel: [close.name, clientName]
                        .filter(Boolean)
                        .join(" "),
                };
            }),
        [closes, clientNamesById],
    );

    const value = filters.taskCloseIds ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val.map(String);
                    onChange({
                        taskCloseIds: selected.length ? selected : undefined,
                    });
                }}
                name="taskClose"
                onBlur={noop}
            />
            {!!filters.taskCloseIds?.length && (
                <FilterActionsFooter
                    deselectFunction={() =>
                        onChange({ taskCloseIds: undefined })
                    }
                    selectedCount={filters.taskCloseIds.length}
                />
            )}
        </div>
    );
};
